import { sgBaseUrl } from '@fs/zion-config'
import axios from '@fs/zion-axios'

export const SNAPSHOT_LOCAL_STORAGE_KEY = 'Lightyear_show_snapshot_in_time'
export const SOUTH_KOREA_PLACE_ID = '279'
export const JAPAN_PLACE_ID = '43'
export const CHINA_PLACE_ID = '221'
export const UNKNOWN_PLACE_ID = '-1'

async function getStandardizedPlace(place) {
  if (!place) {
    return null
  }

  try {
    const url = `${sgBaseUrl}/service/standards/place/ws/places/interp?name=${place.primaryText}`
    const resp = await axios.get(url)

    if (!resp.data.interp) return null

    let foundPlace = null
    const interp = resp.data.interp
    const placeId = parseInt(place.key, 10)

    if (interp.topResults)
      interp.topResults.forEach((result) => {
        if (result.rep.id === placeId)
          foundPlace = { ...result.rep, isStandard: true, primaryText: result.rep.fullDisplay.name }
      })

    if (interp.altReps && !foundPlace)
      interp.altReps.forEach((result) => {
        if (result.rep.id === placeId)
          foundPlace = { ...result.rep, isStandard: true, primaryText: result.rep.fullDisplay.name }
      })

    return foundPlace
  } catch (err) {
    console.error(err)
    return null
  }
}

export function placeDateRangeOverlaps(place, startDate, endDate) {
  let hasOverlap = false

  if ((startDate || endDate) && shouldShowSnapshotDialog()) {
    const startDateObject = new Date(startDate)
    const endDateObject = new Date(endDate)

    const placeFromYear = place?.fromYear ? new Date(place.fromYear, 0, 1) : new Date()
    const placeToYear = place?.toYear ? new Date(place.toYear, 0, 1) : new Date()
    hasOverlap = startDateObject <= placeToYear && endDateObject >= placeFromYear
  }

  return hasOverlap
}

export async function getAlternativePlaces(place, startDate, endDate) {
  if (!place || (!startDate && !endDate)) return null

  const standardPlace = place.isStandard ? place : await getStandardizedPlace(place)
  const overlapCheck = placeDateRangeOverlaps(standardPlace, startDate, endDate)

  if (overlapCheck) return null
  try {
    const placeName = standardPlace.primaryText
    const lowerBaseName = placeName.includes(',') ? standardPlace.primaryText.split(',')[0] : placeName
    const startYear = startDate.split('-')[0]
    const endYear = endDate.split('-')[0]

    // expand the search range since standardized dates include Dec 31st of the year before and Jan 1st of the year after
    const searchDate = `${parseInt(startYear, 10) - 1}-${parseInt(endYear, 10) + 1}`

    const url = `${sgBaseUrl}/service/standards/place/ws/places/interp?name=${lowerBaseName}&center=${placeName}&date=${searchDate}`
    const resp = await axios.get(url)
    const data = resp.data?.interp

    let topResult = null

    const startDateString = new Date(startYear, 0, 1).toISOString().slice(0, 10)
    const endDateString = new Date(endYear, 11, 31).toISOString().slice(0, 10)

    if (data?.topResults?.length) topResult = data.topResults[0]
    else if (data?.altReps?.length) topResult = data.altReps[0]

    if (topResult) {
      const suggestionDatesOverlap = placeDateRangeOverlaps(topResult.rep, startDateString, endDateString)

      if (suggestionDatesOverlap)
        return {
          id: topResult.rep.id,
          fromYear: topResult.rep.fromYear,
          toYear: topResult.rep?.toYear ?? 'Present',
          name: topResult.rep.fullDisplay.name,
        }
    }
  } catch (err) {
    console.error(err)
  }
  return null
}

export function shouldShowSnapshotDialog() {
  try {
    const data = JSON.parse(localStorage[SNAPSHOT_LOCAL_STORAGE_KEY])
    const NOW = new Date()
    const expireDate = new Date(data.expires)

    if (expireDate < NOW) {
      localStorage.removeItem(SNAPSHOT_LOCAL_STORAGE_KEY)
      return true
    }
  } catch (err) {
    return true
  }
  return false
}
